import { Box, styled } from "@mui/material";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

interface AlphabetLetterProps {
  isActive?: boolean;
  isDisabled?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
}

const StyledAlphabetLetter = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isActive" && prop !== "isDisabled",
})<AlphabetLetterProps>(({ theme, isActive, isDisabled }) => ({
  backgroundColor: isActive ? theme.palette.primary.main : "transparent",
  border: "1px solid",
  borderColor: isActive
    ? theme.palette.primary.main
    : theme.palette.custom?.ruleHairline,
  borderRadius: 0,
  color: isActive
    ? theme.palette.primary.contrastText
    : isDisabled
      ? theme.palette.custom?.ruleHairline
      : theme.palette.custom?.link,
  cursor: isDisabled ? "not-allowed" : "pointer",
  pointerEvents: isDisabled ? "none" : "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: FONT_UI,
  fontSize: "0.75rem",
  fontWeight: isActive ? 700 : 600,
  minHeight: "1.75rem",
  minWidth: "1.75rem",
  padding: "0.25rem",
  textTransform: "uppercase",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: isDisabled
      ? "transparent"
      : theme.palette.custom?.newsprintRaised,
    borderColor: isDisabled
      ? theme.palette.custom?.ruleHairline
      : theme.palette.custom?.link,
  },
}));

const AlphabetLetter = ({
  isActive,
  isDisabled,
  children,
  ...props
}: AlphabetLetterProps) => (
  <StyledAlphabetLetter isActive={isActive} isDisabled={isDisabled} {...props}>
    {children}
  </StyledAlphabetLetter>
);

export default AlphabetLetter;
